import React from 'react';
import { Stack } from '@mui/material';
import { withStyles } from '@material-ui/core';
import { VTypography } from '@venti-components';
import styles from './SettlementPreview.styles';
import { useSettlementPreview } from './hook';
import TicketInvoicePreview from '../InvoicePreview/TicketInvoicePreview';
import RebateInvoicePreview from '../InvoicePreview/RebateInvoicePreview';
import VSelectInput from '../../../Venti-UI-Kit/VInputs/VSelectInput/VSelectInput';
import Button from '../../Buttons/Button/Button';
import EditRebateModal from '../Modals/EditRebateModal/EditRebateModal';
import SendSettlementModal from '../Modals/SendSettlementModal/SendSettlementModal';

const SettlementPreview = ({ classes, financialOperations }) => {
  const {
    settlement,
    settlementType,
    onSettlementTypeChange,
    settlementTypeOptions,
    payoutSettings,
    updateRebateSettings,
    rebateModalOpen,
    setRebateModalOpen,
    settlementModalOpen,
    setSettlementModalOpen,
    settlementRecipientEmails,
    sendSettlement,
  } = useSettlementPreview(financialOperations);

  const rebateButtonTitle =
    payoutSettings.rebatePercentage > 0
      ? `Editar Rebate (${payoutSettings.rebatePercentage}%)`
      : 'Agregar Rebate';

  return (
    <Stack className={classes.container}>
      <VTypography variant="h4" align="left" width="100%">
        Liquidación
      </VTypography>
      <Stack direction={{ xs: 'column', md: 'row' }} className={classes.actionsContainer}>
        <VSelectInput
          width={{ xs: '100%', sm: 300 }}
          title="Tipo de Liquidación"
          value={settlementType}
          options={settlementTypeOptions}
          onChange={onSettlementTypeChange}
        />
        <Stack direction={{ xs: 'column', md: 'row' }} gap={1}>
          <Button title={rebateButtonTitle} width={210} onClick={() => setRebateModalOpen(true)} />
          <Button
            title="Enviar Liquidación"
            width={200}
            onClick={() => setSettlementModalOpen(true)}
          />
        </Stack>
      </Stack>
      <Stack marginBottom={2} gap={4} width="100%" direction={{ xs: 'column', md: 'row' }}>
        <TicketInvoicePreview settlement={settlement} />
        <RebateInvoicePreview settlement={settlement} />
      </Stack>
      <EditRebateModal
        open={rebateModalOpen}
        settings={payoutSettings}
        handleClose={() => setRebateModalOpen(false)}
        updateRebate={(values) => {
          updateRebateSettings(values);
          setRebateModalOpen(false);
        }}
      />
      <SendSettlementModal
        open={settlementModalOpen}
        initialSettlementRecipientEmails={settlementRecipientEmails}
        handleClose={() => setSettlementModalOpen(false)}
        handleCreate={sendSettlement}
      />
    </Stack>
  );
};

export default withStyles(styles)(SettlementPreview);
